"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveRetrieveCartCms = void 0;
var SaveRetrieveCartCms = /** @class */ (function () {
    function SaveRetrieveCartCms() {
        this.saveCartHeadingLabel = 'Save cart';
        this.saveCartModalHeadingLabel = 'Save my cart';
        this.inputEmailMessageLable = 'Provide your email address, and we\'ll save your cart for 60 days.';
        this.inputEmailMessageLabel = 'Provide your email address, and we\'ll save your cart for 60 days.';
        this.saveCartModalBodyContainer = 'Need more time? No problem. We can email you a link so you can come back later and pick up where you left off.';
        this.preScreenDisclaimer = '<b>Heads up:</b> We\'ll save your cart without personalized pricing or down payment info. We\'ll see what you qualify for when you come back.';
        this.noteLabel = 'Note:';
        this.emailNoteMessageLabel1 = 'By submitting your email address, you agree to receive future emails from AT&T and its family of companies. We\'ll email you offers';
        this.emailNoteMessageLabel = this.emailNoteMessageLabel1 + "and promotions about AT&T products and services.";
        this.continueShoppingCTALabel = 'Continue shopping';
        this.saveCartCTALabel = 'Save';
        this.cancelCTALabel = 'Cancel';
        this.emailAddressLabel = 'Email address';
        this.privacyNoteMessageLable = 'We have the highest respect for your privacy.' +
            ' The info you provide will be kept secure.' +
            ' For more details, check out our ';
        this.privacyPolicyTextLabel = 'Privacy Policy.';
        this.privacyPolicyLinkLabel = 'https://att.com/privacy';
        this.existingSavedCartErrTxt = 'You already have an existing saved cart associated with the email you provided.';
        this.savingYourCartErrTxt = "Oops, we're having trouble saving your cart. Give it another try.\n     If the problem continues, please try again later.";
        this.replaceItemsMessageLabel = 'To replace the items in that cart with the ones you just added,' +
            ' select ';
        this.retrieveCartMessageLabel = 'To retrieve your previously saved cart instead and empty your active cart,' +
            ' select ';
        this.replaceSavedCartCTALabel = 'Replace and save cart';
        this.retrieveSavedCartCTALabel = 'Retrieve saved cart';
        this.emailErrText = 'Enter a valid email address';
        this.thankYou = {
            allSetLabel: 'You\'re all set',
            continueCtaLabel: 'Continue Shopping',
            daysLabel: 'days.',
            emailNotificationLabel: 'We sent an email to ',
            headsupLabel: 'Heads up: ',
            noteLabel: "Note: We can't guarantee the availability or pricing of equipment or services when you return\n        to retrieve your cart.",
            promoLabel: 'Promos, pricing, and availability might change by the time you return. So, hurry back!',
            retrieveLabel: "To retrieve your cart later, just sign in to your myAT&T account and select the cart icon at the\n            top of the page.",
            saveCartDaysLabel: 'We\'ll save your cart for ',
            thankYouLabel: 'Thank you',
        };
        this.retrieve = {
            activeCartErrTxt: "You currently have an active cart with\n        items in it. If you retrieve a previously\n        saved cart, those items will replace the\n        items in your active cart.",
            apiAddErrTxt: "Well this is embarrasing ",
            cancelCTALabel: 'Cancel',
            chooseLocationLabel: "Which location would you like to use?",
            currentLocationTxt: "Use my current location:",
            descLabel: 'Existing customer?',
            descSignInLabel: 'to retrieve your cart',
            emailErrTxt: 'Enter a valid email address',
            emailLabel: 'Email address',
            enterEmailLabel: 'Enter the email you provided at the time you saved your cart',
            noCartSavedAuthErrTxt: "Hmm... Looks like you don't have a previously saved cart associated with your account",
            noEmailErrTxt: "Hmm... We couldn't find a saved cart\n        for the email address you provided.",
            savedLocationTxt: "Use my saved cart's location:",
            shoppingCTALabel: "Start Shopping",
            signInLabel: 'Sign in ',
            titleLabel: 'Retrieve cart',
            zipCodeMismatchLabel: "The ZIP Code associated with your saved cart doesn't\n         match the one that you're currently using to shop. Keep in mind that changing\n          your location could impact the price and availability of your cart items.",
        };
        this.retrieveYourCartErrTxt = "Oops, we're having trouble retrieving your cart. Give it another try.\n     If the problem continues, please try again later. ";
        this.retrieveYourCartRC1028ErrTxt = "Hmm... We couldn't find a saved cart for the email address you provided";
        this.retrieveYourCartRC1029ErrTxt = "Hmm... Looks like you don't have a previously saved cart associated with\n     your account";
        this.retrieveYourCartRC1030ErrTxt = "Oops, we're having trouble retrieving your cart. Give it another try";
        this.retrieveYourCartRC1031ErrTxt = "Already a customer? Be sure to select the \"Sign in\" link below to\n      retrieve your saved cart";
        this.savedCartItemRemovedTxt = "Uh-oh! Looks like we had to remove one or more items from your saved cart.\n      Those items or offers are no longer available. Be sure to look your cart over before checking out.";
    }
    return SaveRetrieveCartCms;
}());
exports.SaveRetrieveCartCms = SaveRetrieveCartCms;
//# sourceMappingURL=SaveRetrieveCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/SaveRetrieveCart.cms.js
// module id = 1430
// module chunks = 8